import Icons from '@/icons'
import { Tooltip } from 'vnetwork-ui'

const ListIcons = () => {
    return (
        <div className="p-4 flex items-center gap-4 flex-wrap justify-center h-svh overflow-y-auto">
            {Object.keys(Icons).map((key) => {
                const Component = Icons[key as keyof typeof Icons]
                return (
                    <Tooltip
                        key={key}
                        size="small"
                        title={key}
                        placement="bottom"
                    >
                        <Component className="w-8 h-8 cursor-pointer" />
                    </Tooltip>
                )
            })}
        </div>
    )
}

export default ListIcons
